/**
 * All possible fields that a product can require from the dealer during onboarding.
 * Each product in the catalog declares which subset of these it needs via `requiredFields`.
 */
export const ONBOARDING_FIELD = {
	DEALER_NAME: 'dealerName',
	EMAIL: 'email',
	WEBSITE_URL: 'websiteUrl',
	PHONE: 'phone',
	INVENTORY_URLS: 'inventoryUrls',
	BUSINESS_HOURS: 'businessHours',
} as const;

export type OnboardingField = (typeof ONBOARDING_FIELD)[keyof typeof ONBOARDING_FIELD];
